import React from 'react';
import _ from 'lodash';

function Placeholder() {
  return (
    <div className="flex flex-col text-left rounded-md bg-white shadow-sm">
      <div className="flex items-center border-b border-gray-100 mb-2 px-4 h-12">
        <div className="h-2 w-32 bg-gray-100 rounded-full animate-pulse" />
      </div>
      <div className="flex flex-col flex-1 mb-2 p-4 space-y-2">
        {_.times(6, (e) => (
          <div
            key={e}
            className="h-2 w-48 bg-gray-100 rounded-full animate-pulse"
          />
        ))}
      </div>
      <div className="flex items-center justify-end text-left text-right bg-gray-50 rounded-b-md px-4 h-12 border-t border-gray-100 p-4">
        <div className="h-2 w-24 bg-gray-200 rounded-full animate-pulse" />
      </div>
    </div>
  );
}

export default Placeholder;
